<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode conferir todas as inscrições na seleção. Toda nova
              inscrição aparecerá automaticamente na listagem abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--8">
      <div class="row mb-6">
        <div class="col-12">
          <selecao-card v-if="process" :process="process" :count="count" />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div v-if="empty">
            <div class="row">
              <div class="col-12 te text-center">
                <badge type="warning">
                  Nenhuma inscrição na seleção "<b>{{ process.title }}</b
                  >" até o momento
                </badge>
              </div>
            </div>
          </div>
          <div v-else class="card-deck">
            <div
              class="col-lg-3 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="subscription in subscriptions"
              :key="subscription.id"
            >
              <div class="card text-center flex-grow-1">
                <div class="card-body pb-2 pt-3">
                  <h2 class="card-title text-orange mb-1">
                    {{ subscription.name }}
                  </h2>
                  <div>
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ subscription.city || "..." }},
                      {{ subscription.state || "..." }}
                    </div>
                    <div>
                      <div class="h5 font-weight-300 mb-1">
                        <i class="fas fa-envelope mr-2"></i
                        >{{ subscription.email }}
                      </div>
                    </div>
                    <div>
                      <div class="h5 font-weight-300 mb-1">
                        <i class="fas fa-phone mr-2"></i
                        >{{
                          subscription.phone
                            | VMask(
                              `(##) ####${
                                subscription.phone.length > 8 ? "#" : ""
                              }-####`
                            )
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-center">
                  <router-link
                    :to="
                      '/admin/selecoes/' +
                      $route.params.id +
                      '/inscricoes/' +
                      subscription.id
                    "
                    ><i
                      class="fas ml-2 fa-eye text-primary"
                      title="Visualizar inscrição"
                    ></i
                  ></router-link>
                  <span
                    @click="
                      handleOpenModalConfirmation(
                        subscription.id,
                        subscription.name
                      )
                    "
                  >
                    <i
                      class="fas fa-trash ml-3 text-red cursor-pointer"
                      title="Deletar inscrição"
                    ></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-5 mb-1" />
      <div class="row">
        <div class="col text-right">
          <base-button
            type="link"
            :custom="true"
            @click="
              $router.push(`/admin/selecoes/${process.id}/inscricoes-tabela`)
            "
            >Visualizar como tabela</base-button
          >
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalConfirmation"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir a inscrição de
            <span class="text-warning">{{ modals.name }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Todas as informações preenchidas serão perdidas.
          </p>
        </div>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="handleCloseModalConfirmation"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleSubmitRemoveSubscription"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

import SelecaoCard from "./SelecaoCard";

export default {
  name: "selecoes_inscricoes",
  components: {
    SelecaoCard,
  },
  data() {
    return {
      process: "",
      subscriptions: [],
      empty: false,
      count: {
        subscriptions: 0,
      },
      modals: {
        modalConfirmation: false,
        name: "",
        subscriptionId: null,
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      width: 200,
      height: 200,
    });
    try {
      const { data } = await api.get(
        `/adm/recruitment-processes/${this.$route.params.id}?subscriptions=true&count=true`
      );
      if (data.keywords)
        data.keywords = data.keywords.split(";").filter((s) => s);
      if (data.subscriptions.length) this.subscriptions = data.subscriptions;
      else this.empty = true;
      delete data.subscriptions;
      this.count.subscriptions = data.subscriptions_count;
      delete data.subscriptions_count;
      this.process = data;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as inscrições");
    }
  },
  methods: {
    handleOpenEvaluation() {
      this.$router.push(`/admin/selecoes/${this.$route.params.id}/avaliacao`);
    },
    handleOpenModalConfirmation(subscriptionId, startupName) {
      this.modals.subscriptionId = subscriptionId;
      this.modals.name = startupName;
      this.modals.modalConfirmation = true;
    },
    handleCloseModalConfirmation() {
      this.modals.modalConfirmation = false;
      this.modals.subscriptionId = null;
      this.modals.name = "";
    },
    async handleSubmitRemoveSubscription() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(
          `/adm/recruitment-processes/${this.$route.params.id}/subscriptions/${this.modals.subscriptionId}`
        );
        this.$toasted.show("Inscrição removida com sucesso");
        this.$router.go();
      } catch (e) {
        this.error = "Ocorreu um erro ao remover a inscrição";
        this.$toasted.error(this.error);
      } finally {
        loader.hide();
      }
    },
  },
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
